import Component from "@glimmer/component"
import type { CardStack, CardStackSummary } from "@shared/models/card-stack"
import type { Course, Unit } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import UnitIsland from "react-app/islands/UnitIsland"

interface Signature {
  Args: {
    models: {
      cardStack: CardStack
      planbook: Planbook
      rotationCalendar: RotationCalendar
      course: Course
      lessonIsFulfilled: boolean
      unitInfo: Unit
      units: Array<CardStackSummary>
    }
    showUnitReadonly?: boolean
  }
}

export default class UnitIslandBridge extends Component<Signature> {
  readonly UnitIsland = UnitIsland
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Bridges::UnitIslandBridge": typeof UnitIslandBridge
  }
}
